import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Masham',
    title: "Software Engineer",
    desciption:"I am a Software Developer with 3+ year of experience developing, testing, and maintaining enterprise software applications having good experience with MERN/MEAN stack, Relational and NoSql databases, Cloud Platforms and serverless stack.",
    image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    resumePdf: resume
}
